import { z } from "zod";
import { DEFAULT_TOOL_CODE, DEFAULT_TOOL_INPUT_SCHEMA } from "../constants";

/**
 * A user-authored tool, as a prompt or a chat stores it. Schemas are kept as
 * JSON strings, mirroring `structured_output.schema`, so a schema containing
 * `{{ variables }}` survives a round trip through the editor untouched.
 *
 * Deliberately permissive: `ToolBuilderDialog` enforces the real rules (name
 * required, unique, valid identifier, parseable schemas) so a half-authored
 * tool can never make the whole form unsubmittable.
 */
const ToolSchema = z.object({
  id: z.string(),
  name: z.string().default(""),
  description: z.string().default(""),
  input_schema: z.string().default(DEFAULT_TOOL_INPUT_SCHEMA),
  code: z.string().default(DEFAULT_TOOL_CODE),
});

type ToolValues = z.infer<typeof ToolSchema>;

export { ToolSchema, type ToolValues };
